import createStore from '../../payment-calculator-hooks/create-store-hook';
import { FormulaRegistry } from '../../formulas/registry';

import '../../formulas/standardFormula';

const useEstimatorStore = createStore((set, get) => ({
  formula: null,
  monthlyPayment: {
    from: 0,
    to: 0,
  },
  params: {
    price: 0,
    label: 0,
    aprLowerBound: 0,
    aprUpperBound: 0,
    term: 0,
    cashDown: 0,
    formula: null,
    creditRating: null,
  },
  extraParams: {
    docFee: 0,
  },
  setInitialParams: (params, extraParams) => {
   set((state) => ({
     params: {
       ...state.params,
       ...params,
     },
     extraParams: {
      ...state.extraParams,
      ...extraParams,
     },
     formula: params.formula,
   }));

   get().calculatePayment();
 },

  updateParam: (key, value) => {
    set((state) => ({
      params: {
        ...state.params,
        [key]: value,
      },
    }));

    // re-calculate payment
    get().calculatePayment();
  },
  calculatePayment: () => {
    const params = get().params;
    const extraParams = get().extraParams;
    const formula = get().formula;

    const formulaInstance = FormulaRegistry.get(formula);

    if (!formulaInstance) {
      set({ monthlyPayment: { from: 0, to: 0 } });
      set({
        extraParams: {
          ...extraParams,
          amount: params.price - params.cashDown,
        },
      });
      return;
    }

    const { from, to } = formulaInstance.calculate({
      price: params.price,
      downPayment: params.cashDown,
      aprLowerBound: params.aprLowerBound,
      aprUpperBound: params.aprUpperBound,
      term: params.term,
      ...extraParams,
    });

    set({ monthlyPayment: { from, to } });
    // generate extraParams calculated
    set({
      extraParams: {
        ...extraParams,
        amount: params.price - params.cashDown,
      },
    });
  },
}));

export default useEstimatorStore;
